export default "__VITE_ASSET__5e085ea2__"